import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

type WriteOffModalProviderProps = {
  children: ReactNode;
};

type WriteOffModalContextValue = {
  isWriteOffModalOpen: boolean;
  setIsWriteOffModalOpen: (open: boolean) => void;
};

const WriteOffModalContext = createContext<WriteOffModalContextValue>({
  isWriteOffModalOpen: false,
  setIsWriteOffModalOpen: () => null,
});

const WriteOffModalProvider = ({ children }: WriteOffModalProviderProps) => {
  const [isWriteOffModalOpen, setIsWriteOffModalOpen] =
    useState<boolean>(false);

  const value = useMemo(
    () => ({
      isWriteOffModalOpen,
      setIsWriteOffModalOpen,
    }),
    [isWriteOffModalOpen],
  );

  return (
    <WriteOffModalContext.Provider value={value}>
      {children}
    </WriteOffModalContext.Provider>
  );
};

const useWriteOffModal = () => useContext(WriteOffModalContext);

export { WriteOffModalProvider, useWriteOffModal };
